import React from 'react'

function ScheduleCard({ children }) {
  return (
    <div className="flex w-full h-full">
      {children}
    </div>
  )
}

export default ScheduleCard
